import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appEmail]'
})
export class EmailDirective {

  constructor(private el: ElementRef) {}

  @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent): void {
    const inputChar = String.fromCharCode(event.keyCode || event.charCode);

    this.validate(event, inputChar);
  }

  @HostListener('paste', ['$event'])
  onPaste(event: Event) {
    const pastedText = (window as any).clipboardData && (window as any).clipboardData.getData('Text') // If IE, use window
      || event as ClipboardEvent && (event as ClipboardEvent).clipboardData.getData('text/plain'); // Non-IE browsers

    this.validate(event, pastedText);
  }

  validate(event: Event, text: string) {
    let allowedChars: string = '^[a-zA-Z0-9._@-]+$';
    
    if (!new RegExp(allowedChars).test(text)) {
      event.preventDefault();
    }
  }
}
